import React, { useEffect, useState, useCallback, useRef } from 'react';
import { FaFire, FaGlobe } from 'react-icons/fa';
import { FixedSizeGrid as Grid } from 'react-window';
import { useInView } from 'react-intersection-observer';
import { AsyncImage } from 'loadable-image';
import { Blur } from 'transitions-kit';

// Cell component defined outside of ImageGrid to maintain stable identity
const Cell = React.memo(({ columnIndex, rowIndex, style, data }) => {
  const { images, selectedData,sectionName, memoizedHandleImageSelect,character } = data;
  const index = rowIndex * data.columnCount + columnIndex;
  const [markedImages,setMarkedImages]=useState([])
  useEffect(()=>{
    if(selectedData[sectionName].imageData){

      const existingCharacterIndex =selectedData[sectionName].imageData.findIndex(
        (item) => item.characterName === character
      );
  
      if (existingCharacterIndex !== -1) {
       
        const characterImages = selectedData[sectionName].imageData[existingCharacterIndex].images;
        setMarkedImages([...characterImages])
      }

    }
   
    
  },[selectedData])

useEffect(()=>{
  console.log(markedImages)
})

  // Move useInView to the top level
  const { ref: containerRef, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  // Return null if the index is out of bounds
  if (index >= images.length) return null;

  const image = images[index];
  

  return (
    <div style={style} ref={inView ? containerRef : null}>
      <div
        className="composition-image-container"
        onClick={() => memoizedHandleImageSelect(image)}
      >
        <AsyncImage
          src={image}
          style={{ width: 200, height: 200, objectFit: 'contain' }}
          loader={<div style={{ background: '#888' }} />}
          error={<div style={{ background: '#eee' }} />}
          Transition={Blur}
        />
        {markedImages?.includes(image) && <FaFire className="fire-icon" />}
      </div>
    </div>
  );
});

// ImageGrid component
const ImageGrid = ({ images, selectedData, sectionName,character, handleImageSelect }) => {
  const gridRef = useRef();

  const [dimensions, setDimensions] = useState({
    columnCount: 4,
    containerWidth: 0,
  });

 
 
  // Calculate layout dynamically
  const calculateLayout = useCallback(() => {
    if (!gridRef.current) return;
    const width = gridRef.current.offsetWidth;

    setDimensions((prev) => {
      if (prev.containerWidth === width) return prev; // Avoid redundant updates
      return {
        containerWidth: width,
        columnCount: Math.max(Math.floor(width / 200), 1),
      };
    });
  }, []);

  // Handle window resize
  useEffect(() => {
    calculateLayout();
    const debouncedResize = debounce(calculateLayout, 150);
    window.addEventListener('resize', debouncedResize);
    return () => window.removeEventListener('resize', debouncedResize);
  }, [calculateLayout]);

  const { columnCount, containerWidth } = dimensions;
  const rowCount = Math.ceil(images.length / columnCount);
  const columnWidth = containerWidth / Math.max(columnCount, 1);

  // Memoized click handler
  const memoizedHandleImageSelect = useCallback(
    (image) => {
      handleImageSelect(image, character);
    },
    [handleImageSelect, character]
  );

  // Data to pass to Cell
  const itemData = {
    images,
    selectedData,
    sectionName,
    memoizedHandleImageSelect,
    columnCount,
    character
  };

  if (!images.length) return null;

  return (
    <div ref={gridRef} className="composition-images">
      <Grid
        itemData={itemData}
        columnCount={columnCount}
        rowCount={rowCount}
        columnWidth={columnWidth}
        rowHeight={220}
        width={containerWidth}
        height={600}
        overscanRowCount={2}
      >
        {Cell}
      </Grid>
    </div>
  );
};

// Debounce utility function
const debounce = (fn, ms) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), ms);
  };
};

export default React.memo(ImageGrid);